/*
*    JavaScript autoComplete v1.0.4
*    Copyright (c) 2014 Simon Steinberger / Pixabay
*    GitHub: https://github.com/Pixabay/JavaScript-autoComplete
*    License: http://www.opensource.org/licenses/mit-license.php
    
*    Based off of the above but had to make many changes for accessibility and proper structure - MML 11/2/18
*/

var autoComplete = (function(){
	var autoComplete = function(options){
		if (!document.querySelector) return;
		
        	var hasClass = function(el, className){ 
        		return el.classList ? el.classList.contains(className) : new RegExp('\\b'+ className+'\\b').test(el.className);
        	},
		addEvent = function(el, type, handler){
           		if (el.attachEvent) {
           			el.attachEvent('on'+type, handler); 
           		} else {
           			el.addEventListener(type, handler);
           		}
        	},
        	removeEvent = function(el, type, handler){
            		if (el.detachEvent) {
            			el.detachEvent('on'+type, handler); 
            		} else {
            			el.removeEventListener(type, handler);
            		}
        	},
        	live = function(elClass, event, cb, context){
            		addEvent(context || document, event, function(e){
                		var found, el = e.target || e.srcElement;
                		while (el && !(found = hasClass(el, elClass))) el = el.parentElement;
                		if (found) {
                			cb.call(el, e);
                		}
            		});
        	},
		o = {
			appendTo: 0,
            		selector: 0,
            		source: 0,
            		minChars: 3,
            		delay: 150,
            		offsetLeft: 0,
            		offsetTop: 1,
            		cache: 1,
            		menuClass: '',
            		renderItem: function (item, search){
                		// escape special characters
                		search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
               	 	var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
                		return '<li role="option" aria-selected="false" class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>") + '</li>';
            		},
            		onSelect: function(e, term, item){},
            		termSelected: function(e, term, item){},
            		onClose: function(){}
        	};
        	for (var k in options) { if (options.hasOwnProperty(k)) o[k] = options[k]; }

        	// init
        	var elems = typeof o.selector == 'object' ? [o.selector] : document.querySelectorAll(o.selector);
        	for (var i=0; i<elems.length; i++) {
            		var inputElement = elems[i];

            		// create suggestions container "sc"
           	 	inputElement.sc = document.createElement('ul'); 
            		inputElement.sc.className = 'autocomplete-suggestions reset resetList ' + o.menuClass;
            		inputElement.sc.id = 'searchResults'; 
            		inputElement.sc.setAttribute("role", "listbox");
            		inputElement.sc.setAttribute("aria-label", "Search Autocomplete"); 
            		inputElement.sc.setAttribute("aria-hidden", "true"); 

            		inputElement.autocompleteAttr = inputElement.getAttribute('autocomplete');
            		inputElement.setAttribute('autocomplete', 'off');
            		inputElement.cache = {};
            		inputElement.last_val = '';

            		inputElement.updateSC = function(resize, next){
                		var rect = inputElement.getBoundingClientRect();
                		inputElement.sc.style.width = Math.round(rect.right - rect.left) + 'px'; // outerWidth
                		if (!resize) {
                    			inputElement.sc.style.display = 'block';
                    			inputElement.setAttribute("aria-expanded", "true");
                    			inputElement.sc.setAttribute("aria-hidden", "false");
                    			
                    			if (!inputElement.sc.maxHeight) { 
                    				inputElement.sc.maxHeight = parseInt((window.getComputedStyle ? getComputedStyle(inputElement.sc, null) : inputElement.sc.currentStyle).maxHeight); 
                    			}
                    			if (!inputElement.sc.suggestionHeight) {
                    				inputElement.sc.suggestionHeight = inputElement.sc.querySelector('.autocomplete-suggestion').offsetHeight;
                    			}
                    			if (inputElement.sc.suggestionHeight){
                        			if (!next) {
                        				inputElement.sc.scrollTop = 0;
                        			} else {
                            			var scrTop = inputElement.sc.scrollTop, 
                            			selTop = next.getBoundingClientRect().top - inputElement.sc.getBoundingClientRect().top;
                            			
                            			if (selTop + inputElement.sc.suggestionHeight - inputElement.sc.maxHeight > 0){
                                				inputElement.sc.scrollTop = selTop + inputElement.sc.suggestionHeight + scrTop - inputElement.sc.maxHeight;
                                			} else if (selTop < 0){
                                				inputElement.sc.scrollTop = selTop + scrTop;
                                			}
                        			}
                			}
           			 }
           		};
            		addEvent(window, 'resize', inputElement.updateSC);
            		o.appendTo.appendChild(inputElement.sc);

			live('autocomplete-suggestion', 'mouseleave', function(e){
                		var sel = inputElement.sc.querySelector('.autocomplete-suggestion.selected');
                		if (sel) {
                			setTimeout(function(){ 
                				sel.classList.remove('selected');  
                				sel.setAttribute('aria-selected', 'false');
                				sel.setAttribute('id', "");
                			}, 20);
                		}
            		}, inputElement.sc);

            		live('autocomplete-suggestion', 'mouseover', function(e){
                		var sel = inputElement.sc.querySelector('.autocomplete-suggestion.selected');
                		var activeItemId = 'selectedOption';
                		if (sel){ 
                			sel.classList.remove('selected'); 
                			sel.setAttribute('aria-selected', 'false');
                			sel.setAttribute('id', ""); 
                		} 
                		this.className += ' selected';
                		this.setAttribute('aria-selected', 'true');
                		this.setAttribute('id', activeItemId); 
                		document.getElementById("txtSearch").setAttribute('aria-activedescendant', activeItemId);
                		o.termSelected(e, this.getAttribute('data-val'), this);
            		}, inputElement.sc); 
            
            		live('autocomplete-suggestion', 'mousedown', function(e){
                		if (hasClass(this, 'autocomplete-suggestion')) { // else outside click
                    			var v = this.getAttribute('data-val');
                    			inputElement.value = v;
                    			o.onSelect(e, v, this);
                    			inputElement.sc.style.display = 'none';
                    			inputElement.sc.setAttribute("aria-hidden", "true");
                    			inputElement.setAttribute("aria-expanded", "false");
                    			o.onClose();
                		}
            		}, inputElement.sc);

	            	inputElement.blurHandler = function(){
	            		var over_sb;
	                	try { 
	                		over_sb = document.querySelector('.autocomplete-suggestions:hover');
	                	} catch(e){ 
	                		over_sb = 0; 
	                	}
	                	if (!over_sb) {
	                    		inputElement.last_val = inputElement.value;
	                    		inputElement.sc.style.display = 'none';
	                    		inputElement.sc.setAttribute("aria-hidden", "true");
	                    		inputElement.setAttribute("aria-expanded", "false");
	                    		o.onClose();
	                    		setTimeout(function(){ 
	                    			inputElement.sc.style.display = 'none';
	                    			inputElement.sc.setAttribute("aria-hidden", "true");
	                    			inputElement.setAttribute("aria-expanded", "false");
	                    			o.onClose();
	                    		}, 350); // hide suggestions on fast input
	                	} else if (inputElement !== document.activeElement) {
	                		setTimeout(function(){ 
	                			inputElement.focus(); 
	                		}, 20);
	                	}
	            	};
	            	addEvent(inputElement, 'blur', inputElement.blurHandler);
		
			var suggest = function(data){
                		var val = inputElement.value;
                		inputElement.cache[val] = data;
                		if (data.length && val.length >= o.minChars) {
                    			var s = '';
                    			for (var i=0;i<data.length;i++) {
                    				s += o.renderItem(data[i], val);
                    			}
                   	 		inputElement.sc.innerHTML = s;
                    			inputElement.updateSC(0);
                		} else {
                    			inputElement.sc.style.display = 'none';
                    			inputElement.sc.setAttribute("aria-hidden", "true");
                    			inputElement.setAttribute("aria-expanded", "false");
                    			o.onClose();
                    		}
            		};

            		inputElement.keydownHandler = function(e){
                		var key = window.event ? e.keyCode : e.which;
                		var sel;
                		if ((key == 40 || key == 38) && inputElement.sc.innerHTML) {
                    			var next;
                    			sel = inputElement.sc.querySelector('.autocomplete-suggestion.selected');
                    			if (!sel) {
                        			next = (key == 40) ? inputElement.sc.querySelector('.autocomplete-suggestion') : inputElement.sc.childNodes[inputElement.sc.childNodes.length - 1]; // first : last
                        			next.className += ' selected';
                        			inputElement.value = next.getAttribute('data-val');
                        			o.termSelected(e, next.getAttribute('data-val'), next);
                    			} else {
                        			next = (key == 40) ? sel.nextSibling : sel.previousSibling;
                       	 		if (next) {
                            			sel.classList.remove('selected');
                            			next.className += ' selected';
                            			inputElement.value = next.getAttribute('data-val');
                            			o.termSelected(e, next.getAttribute('data-val'), next);
                        			} else { 
                        				sel.classList.remove('selected'); 
                        				inputElement.value = inputElement.last_val; next = 0; 
                        			}
                    			}
                    			inputElement.updateSC(0, next);
                    			return false;
                		} else if (key == 27) {  // esc
                			inputElement.value = inputElement.last_val; 
                			inputElement.sc.style.display = 'none'; 
                			inputElement.sc.setAttribute("aria-hidden", "true"); 
                			inputElement.setAttribute("aria-expanded", "false");
                			o.onClose();
                		} /*else if (key == 13 || key == 9) {  // enter tab
                   			sel = inputElement.sc.querySelector('.autocomplete-suggestion.selected');
                    			if (sel && inputElement.sc.style.display != 'none') { 
                    				o.onSelect(e, sel.getAttribute('data-val'), sel); 
                    				setTimeout(function(){ 
                    					inputElement.sc.style.display = 'none'; 
                    					inputElement.sc.setAttribute("aria-hidden", "true"); 
                    				}, 20); 
                			}
                		}*/
            		};
            		addEvent(inputElement, 'keydown', inputElement.keydownHandler);

            		inputElement.keyupHandler = function(e){
                		var key = window.event ? e.keyCode : e.which;
                		if (!key || (key < 35 || key > 40) && key != 13 && key != 27) {
                    			var val = inputElement.value;
                    			if (val.length >= o.minChars) {
                        			if (val != inputElement.last_val) {
                            			inputElement.last_val = val;
                            			clearTimeout(inputElement.timer);
                            			if (o.cache) {
                                				if (val in inputElement.cache) { 
                                					suggest(inputElement.cache[val]); 
                                					return; 
                                				}
                                				for (var i=1; i<val.length-o.minChars; i++) {
                                    				var part = val.slice(0, val.length-i);
                                    				if (part in inputElement.cache && !inputElement.cache[part].length) { 
                                    					suggest([]); 
                                    					return; 
                                    				}
                                				}
                            			}
                            			inputElement.timer = setTimeout(function(){ 
                            				o.source(val, suggest);
                            			}, o.delay);
                       		 	}
                    			} else {
                    				inputElement.last_val = val;
                        			inputElement.sc.style.display = 'none';
                        			inputElement.sc.setAttribute("aria-hidden", "true");
                        			inputElement.setAttribute("aria-expanded", "false");
                        			o.onClose();
                    			}
                		}
            		};
            		addEvent(inputElement, 'keyup', inputElement.keyupHandler);

            		inputElement.focusHandler = function(e){
                		inputElement.last_val = '\n';
                		inputElement.keyupHandler(e);
            		};
            		if (!o.minChars) {
            			addEvent(inputElement, 'focus', inputElement.focusHandler);
            		}
		}
	
		// public destroy method
		this.destroy = function(){
			for (var i=0; i<elems.length; i++) {
				var inputElement = elems[i];
	                	removeEvent(window, 'resize', inputElement.updateSC);
	                	removeEvent(inputElement, 'blur', inputElement.blurHandler);
	                	removeEvent(inputElement, 'focus', inputElement.focusHandler);
	                	removeEvent(inputElement, 'keydown', inputElement.keydownHandler);
	                	removeEvent(inputElement, 'keyup', inputElement.keyupHandler);
	                	if (inputElement.autocompleteAttr){
	                    		inputElement.setAttribute('autocomplete', inputElement.autocompleteAttr);
	                    	}else{
	                    		inputElement.removeAttribute('autocomplete');
	                    		o.appendTo.removeChild(inputElement.sc);
	                		inputElement = null;
	            		}
	        	}
	    	};
    	};
    	return autoComplete;
})();

(function(){
	if (typeof define === 'function' && define.amd)
		define('autoComplete', function () { return autoComplete; });
	else if (typeof module !== 'undefined' && module.exports)
		module.exports = autoComplete;
	else
		window.autoComplete = autoComplete;
})();